<template>

  <panel-navigation>

    <div class="rg-top-filter pt-1 float-right mr-2">
      <v-text-field
          :value="formatDate(date_filter[0], 'MMM DD, YYYY') + '   -   ' + ((date_filter[1]) ? formatDate(date_filter[1], 'MMM DD, YYYY') : '')"
          append-icon="mdi-calendar-blank-outline"
          readonly
          outlined
          dense
          style="width: 230px; background: #4EC5A1; color: #FFFFFF !important; border: 0px !important;"
          hide-details
          placholder="Choose Date"
          @click="show_picker = !show_picker"
      ></v-text-field>
      
      <div v-if="show_picker" style="position: absolute; width: 490px; z-index: 999; margin-left: -260px; background: #FFFFFF; padding: 10px; margin-top: 5px; border-radius: 10px; box-shadow: 0px 0px 30px 0px #E2E2E2;">
          <div style="float: left; border-right: solid 1px #d5d5d5;">
          <div class="mb-2"><strong class="text-sm">Filter by Date</strong></div>

          <v-date-picker
          v-model="date_filter"
          range
          no-title
          scrollable
          @input="menu = false"
          style="border: 0px;"
          >
          <v-spacer></v-spacer>
              <v-btn
                  text
                  color="#44468F"
                  @click="show_picker = false"
              >
                  Cancel
              </v-btn>
              <v-btn
                  text
                  color="#44468F"
                  @click="filterDate();"
              >
                  UPDATE
              </v-btn>
          </v-date-picker>
          </div>

          <div style="float: left; margin-left: 20px; padding-left: 20px; padding-top: 20px;">
          <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('This Week')" :style="((selected_date_text == 'This Week') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">This Week</a></div>
          <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last Week')" :style="((selected_date_text == 'Last Week') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last Week</a></div>
          <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('This Month')" :style="((selected_date_text == 'This Month') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">This Month</a></div>
          <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last Month')" :style="((selected_date_text == 'Last Month') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last Month</a></div>
          <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last 60 days')" :style="((selected_date_text == 'Last 60 days') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last 60 days</a></div>
          <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last 90 days')" :style="((selected_date_text == 'Last 90 days') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last 90 days</a></div>
          <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('This Year')" :style="((selected_date_text == 'This Year') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">This Year</a></div>
          <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last Year')" :style="((selected_date_text == 'Last Year') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last Year</a></div>
          <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('All Time')" :style="((selected_date_text == 'All Time') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">All Time</a></div>
          </div>

          <div style="clear: both;"></div>
      </div>
  </div>
    
    <h1 class="text-lg font-semibold mb-3">Activity</h1>

    <hr class="border-b border-gray-100 mb-3">

    <div v-if="fetchingActivity">
    <br /><br />
    <v-skeleton-loader type="article, article, article"></v-skeleton-loader>
    </div>

    <div v-if="!fetchingActivity" class="flex flex-row flex-wrap mb-3">
        <div class="dashboard-box stats-box w-full px-2 mb-4">
            <v-card
            class="pa-2"
            tile
            >
            <div class="p-3">
                <div v-if="activity.length == 0" class="flex flex-col justify-center items-center">
                <div class="text-gray-300">
                    <!-- <img src="@/assets/images/icons/empty.svg" alt="" class="mt-16" style="max-width: 200px;"> -->
                </div>
                <div class="text-center mt-6 mb-16 text-gray-600 text-md" style="padding: 102px;">No activity yet.</div>
                </div>

                <div v-else class="">

                  <v-text-field
                          clearable
                          outlined
                          dense
                          hide-details
                          prepend-inner-icon="mdi-magnify"
                          label="Search"
                          v-model="search"
                          @change="fetchActivity()"
                          class="white border border-white"
                  ></v-text-field>
                  
                <div v-for="activity_item in activity" :key="activity_item.id" class="text-sm pt-3 text-gray-800 bg-white rounded">
                    <!-- <div class="float-left mr-2"><svg width="20" height="20"  class="fill-current" viewBox="0 0 1941 1941" xmlns="http://www.w3.org/2000/svg"><path d="M906.667 1088v384q0 80-56 136t-136 56h-384q-80 0-136-56t-56-136V768q0-104 40.5-198.5t109.5-163.5 163.5-109.5 198.5-40.5h64q26 0 45 19t19 45v128q0 26-19 45t-45 19h-64q-106 0-181 75t-75 181v32q0 40 28 68t68 28h224q80 0 136 56t56 136zm896 0v384q0 80-56 136t-136 56h-384q-80 0-136-56t-56-136V768q0-104 40.5-198.5t109.5-163.5 163.5-109.5 198.5-40.5h64q26 0 45 19t19 45v128q0 26-19 45t-45 19h-64q-106 0-181 75t-75 181v32q0 40 28 68t68 28h224q80 0 136 56t56 136z"/></svg></div> -->
                    <div class="dashboard-activity-item">
                    <strong>
                        <span v-if="activity_item.user.first_name || activity_item.user.last_name">{{ activity_item.user.first_name }} {{ activity_item.user.last_name }}</span>  
                    </strong>
                    {{ activity_item.details.toLowerCase() }}
                    <span class="float-right not-mobile" style="font-size: 12px;">
                        {{ formatDate(activity_item.created_at) }}
                    </span>
                    <div class="mobile-only mt-1" style="font-size: 12px; font-style: italic;">
                        <i class="fa fa-calendar"></i> {{ formatDate(activity_item.created_at) }}
                    </div>
                    <br class="not-mobile" clear="all" />
                    <div v-if="activity_item.user.company_type == 'location'" class="" style="font-size: 12px;">
                        <i class="mdi mdi-briefcase-outline" style="font-size: 16px;"></i>
                        &nbsp;
                        {{ activity_item.user.parent.company_name }}
                        <span class="not-mobile">&nbsp;&nbsp;
                        |
                        &nbsp;&nbsp;
                        </span>
                        <br class="mobile-only" />
                        <span>
                        <span class="not-mobile">&nbsp;&nbsp;</span>
                        <i class="mdi mdi-map-marker-outline" style="font-size: 16px;"></i>
                        <span class="not-mobile">&nbsp;</span>&nbsp;
                        {{ activity_item.user.address }} {{ activity_item.user.street_number }}<span v-if="(activity_item.user.address || activity_item.user.street_number)">, </span>{{ activity_item.user.city }} <span v-if="!activity_item.user.city">{{ activity_item.user.country }}</span> &nbsp;<span v-if="activity_item.user.parent.company_type == 'business'" style="font-weight: bold;">(Main)</span>
                        </span>
                    </div>

                    <div v-if="activity_item.user.company_type != 'location'" class="" style="font-size: 12px;">
                        <i class="mdi mdi-briefcase-outline" style="font-size: 16px;"></i>
                        &nbsp;
                        {{ activity_item.user.company_name }}
                        <span class="not-mobile">&nbsp;&nbsp;
                        |
                        &nbsp;&nbsp;
                        </span>
                        <br class="mobile-only" />
                        <span>
                        <span class="not-mobile">&nbsp;&nbsp;</span>
                        <i class="mdi mdi-map-marker-outline" style="font-size: 16px;"></i>
                        <span class="not-mobile">&nbsp;</span>&nbsp;
                        {{ activity_item.user.address }} {{ activity_item.user.street_number }}<span v-if="(activity_item.user.address || activity_item.user.street_number)">, </span>{{ activity_item.user.city }} <span v-if="!activity_item.user.city">{{ activity_item.user.country }}</span> &nbsp;<span v-if="activity_item.user.company_type == 'business'" style="font-weight: bold;">(Main)</span>
                        </span>
                    </div>
                    </div>
                    <div style="clear: both;"></div>
                </div>
                </div>
            </div>
            </v-card>
        </div>
    </div>

  </panel-navigation>

</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
import PanelNavigation from '@/components/PanelNavigation.vue'
import moment from 'moment'

export default {
  components: {
    PanelNavigation
  },
  data () {
    return {
      show_picker: false,
        
      date_filter: [
            moment().startOf('week').format('YYYY-MM-DD'),
            moment().endOf('week').format('YYYY-MM-DD')
      ],

      archived_filter: 'Show Unarchived',

      all_time: 0,

      selected_date_text: "This Week",
      
      search: "",
    }
  },
  computed: {
    ...mapState({
      me: (state) => state.me.me,
      activity: state => state.activity.activity,
      fetchingActivity: state => state.activity.fetchingActivity
    }),
  },
  methods: {
    formatDate: function(date, format = "MM/DD/YYYY") {
        return moment(String(date)).format(format)
    },

    fetchActivity() {
      this.$store.dispatch('activity/fetch', {
        search: this.search,
        date_filter: this.date_filter
      })
    },

    applyDate(selected_date) {
      this.all_time = 0;
      // console.log('selected_date', selected_date);
      this.selected_date_text = selected_date;
      switch (selected_date) {
        case 'This Week':
          this.date_filter[0] = moment().startOf('week').format('YYYY-MM-DD');
          this.date_filter[1] = moment().endOf('week').format('YYYY-MM-DD');
        break;
        case 'Last Week':
          this.date_filter[0] = moment().startOf('week').subtract(7, 'days').format('YYYY-MM-DD');
          this.date_filter[1] = moment().endOf('week').subtract(7, 'days').format('YYYY-MM-DD');
        break;
        case 'This Month':
          this.date_filter[0] = moment().startOf('month').format('YYYY-MM-DD');
          this.date_filter[1] = moment().endOf('month').format('YYYY-MM-DD');
        break;
        case 'Last Month':
          this.date_filter[0] = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
          this.date_filter[1] = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
        break;
        case 'Last 60 days':
          this.date_filter[0] = moment().subtract(60, 'days').format('YYYY-MM-DD');
          this.date_filter[1] = moment().format('YYYY-MM-DD');
        break;
        case 'Last 90 days':
          this.date_filter[0] = moment().subtract(90, 'days').format('YYYY-MM-DD');
          this.date_filter[1] = moment().format('YYYY-MM-DD');
        break;
        case 'This Year':
          this.date_filter[0] = moment().startOf('year').format('YYYY-MM-DD');
          this.date_filter[1] = moment().endOf('year').format('YYYY-MM-DD');
        break;
        case 'Last Year':
          this.date_filter[0] = moment().startOf('year').subtract(1, 'year').format('YYYY-MM-DD');
          this.date_filter[1] = moment().endOf('year').subtract(1, 'year').format('YYYY-MM-DD');
        break;

        case 'All Time':
          this.date_filter[0] = moment().startOf('year').subtract(10, 'years').format('YYYY-MM-DD');
          this.date_filter[1] = moment().format('YYYY-MM-DD');
          
          this.all_time = 1;
        break;
      }
      // console.log(this.date_filter);
      this.show_picker = false;
      this.fetchActivity();
    },
  },
  created() {
    this.$store.state.activity.fetchingActivity = true
    this.fetchActivity();
  }
}
</script>

<style type="text/css">
  
</style>